<template>
  <div v-if="!error && ribbonData.length" class="grid md:grid-flow-col text-center md:auto-cols-fr">
    <div v-for="item in ribbonData" :key="item.key" :class="[item.bgClass, 'flex items-center justify-center px-3 py-1.5']">
      <div class="flex items-center justify-center font-semibold md:text-base text-sm">
        <component
          :is="item.config.element"
          v-bind="item.config.attrs"
          :class="[item.textClass, { 'hover:underline': item.content }]"
          @click="openModal(item.key)"
        >
          {{ item.text }}
        </component>
      </div>
    </div>
  </div>

  <BaseModal
    v-for="item in ribbonData"
    :key="item.key"
    :open="openStates[item.key]"
    @close="openStates[item.key] = false"
  >
    <p class="gamma mb-4">
      {{ item.text }}
    </p>
    <p>{{ item.content }}</p>
  </BaseModal>
</template>

<script setup lang="ts">
const { getPageMessageData } = useLexas()
const { data, error } = await getPageMessageData()

const linkLeft = data.value?.linkLeft
const textLeft = data.value?.textLeft
const contentLeft = data.value?.contentLeft
const linkRight = data.value?.linkRight
const textRight = data.value?.textRight
const contentRight = data.value?.contentRight

const NuxtLink = resolveComponent('NuxtLink')

const ribbonData = computed(() => [
  {
    key: 'left',
    text: textLeft,
    content: contentLeft,
    link: linkLeft,
    config: linkConfig(linkLeft, contentLeft),
    bgClass: 'bg-gold-200',
    textClass: 'text-pine-950 decoration-pine-950'
  },
  {
    key: 'right',
    text: textRight,
    content: contentRight,
    link: linkRight,
    config: linkConfig(linkRight, contentRight),
    bgClass: 'bg-pine-950',
    textClass: 'text-gold-100 decoration-gold-100'
  }
  // If 'text' is empty, filter item out
].filter(item => item.text))

const linkConfig = (link?: string | null, content?: string | null) =>
  !link
  // If link doesn't exist, check if content exists
    ? content
    // If link doesn't exist but content exists, use button element
      ? { element: 'button', attrs: { type: 'button' } }
    // If link and content are both empty, use div
      : { element: 'div', attrs: {} }
  // If link exists, check if it's external (http or https)
    : /^(http|https):\/\//.test(link)
    // If external, use anchor element
      ? { element: 'a', attrs: { href: link, target: '_blank', rel: 'noopener noreferrer' } }
    // If not external, use NuxtLink
      : { element: NuxtLink, attrs: { to: link } }

// Reactive object to manage modal open states
const openStates = reactive<{ [key: string]: boolean }>({
  left: false,
  right: false
})

const openModal = (key: string) => {
  const data = ribbonData.value.find(i => i.key === key)
  // If link exists or content is empty, modal won't open..
  if (data?.link || !data?.content) return
  // ..otherwise set open state to true by the key
  openStates[key] = true
}
</script>
